import React, { useState, useEffect } from 'react';
import loadable from '@loadable/component';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// api
// import userApi from '../../../../src/apis/userApi';

// helpers
import { getProfileLogo, getProfileName } from './Helpers/sice-profile-helpers';
import CompanyContactButton from './CompanyContactButton';
import SkeletonComponent from '/src/components/Reusable/SkeletonComponent'

const ProfileHeader = (props) => {
    const { entityId, siceEntity, owner, user, entityType, editPage, setState, page } = props;

    // const [followStatus, setFollowStatus] = useState(false);
    // const [isUpdatingFollowStatus, setIsUpdatingFollowStatus] = useState(false);
    const [showSkeleton, setShowSkeleton] = useState(true);

    // const getUserFollowStatus = async () => {
    //     const { user, entityType, entityId } = props;

    //     if (entityType == "user" || entityType == "people") {
    //         return;
    //     }
    //     if (user && user.is_loggedin) {
    //         await userApi.getUserEntityFollowStatus(entityId, entityType).then(
    //             response => {
    //                 let status = false;

    //                 if (response && response.length > 0) {
    //                     status = response[0] && response[0].is_user_following ? response[0].is_user_following : false;
    //                 }
    //                 setFollowStatus(status);
    //             }
    //         )
    //     }
    // }
    // const handleFollow = async () => {
    //     setIsUpdatingFollowStatus(true);

    //     await userApi.updateUserEntityFollowStatus(entityId, entityType).then((res) => {
    //         if (res)
    //             setFollowStatus(!followStatus);

    //         setIsUpdatingFollowStatus(false);
    //     })
    // }


    // useEffect(() => {
    //     if (!editPage) {
    //         getUserFollowStatus();
    //     }
    // }, []);

    const profileLogo = getProfileLogo(siceEntity);
    const name = getProfileName(siceEntity);

    // variables for visibility of elements
    const hasWebsiteLink = (siceEntity?.website !== undefined && siceEntity?.website !== null && siceEntity?.website.length > 0);

    return (
        <div className="profile-header profile-section-box single-profile-box">
            <div className="profile-logo-box">
                {showSkeleton ?
                    <SkeletonComponent
                        SkeletonClassName="logoBlock-skeleton"
                        useTimeout={true}
                        actionOnTimeout={() => setShowSkeleton(false)}
                    /> : profileLogo}
            </div>
            <div className="profile-name-box">
                <h1>{name}</h1>
                
                {!editPage &&
                    <div className="profile-header-btns">

                        {/* Keep 2 actions on the top of the page */}
                        {/* (1) website link and (2) Company Email*/}

                        {/* default secondary action */}
                        {hasWebsiteLink &&
                            <a className="btn btn-main-outline btn-sm" href={siceEntity?.website} target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-globe"></i>
                                Visit Website
                            </a>
                        }

                        <CompanyContactButton user={user} owner={owner} id={entityId} entityType={entityType} setState={setState} page={page} />

                    </div>
                }
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    userData: state.userReducer
});
export default withRouter(connect(mapStateToProps, null)(ProfileHeader))